import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Table,
  Form,
  Input,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
  ButtonGroup
} from "reactstrap";
// core components
import { toast } from "react-toastify";
import { FaDownload } from 'react-icons/fa';

import CustomTable from "components/CustomTable";
import { useParams } from 'react-router-dom';  // Import useParams to capture the student ID
import { apiURL1 } from '../../config';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { FaPrint } from 'react-icons/fa';
import Footer from "components/Footers/Footer";



import React, { useState, useEffect } from "react";

import { FaPencilAlt, FaTrash, FaPlus } from 'react-icons/fa';

const TeacherDetail = () => {

  const [activeTab, setActiveTab] = useState("manage");
  const token = localStorage.getItem("token");

  return (
    <>
      <div
        className="header   d-flex align-items-center"
        style={{
          minHeight: "600px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Mask */}
        <span className="mask bg-gradient-default opacity-8" />
        {/* Header container */}
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="7" md="10">
              <h1 className="display-2 text-white">Student Management</h1>
              <p className="text-white mt-0 mb-5">
                Here you can view and manage the details of the students in your
                care. Review the information carefully and make any necessary
                updates or follow-ups.
              </p>
              <Button
                color={activeTab === "manage" ? "info" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("manage");
                }}
              >
                Manage Student
              </Button>
              <Button
                color={activeTab === "fee" ? "info" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("fee");
                }}
              >
                Fee Management
              </Button>
              {/* <Button
                color={activeTab === "attendance" ? "danger" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("attendance");
                }}
              >
                Attendance Tracking
              </Button>
              <Button
                color={activeTab === "leave" ? "warning" : "secondary"}
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("leave");
                }}
              >
                Leave Management
              </Button> */}
            </Col>
          </Row>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {activeTab === "attendance" && <AttendanceTracking />}
        {activeTab === "leave" && <LeaveManagement />}
        {activeTab === "manage" && <ManageStudent />}
        {activeTab === "fee" && <FeeManagement />}
      </Container>
    </>
  );
};
export default TeacherDetail;

const AttendanceTracking = () => {
  const token = localStorage.getItem("token");

  const columns = ["Date", "Attendance Type", "Present", "Absent", "Late"];
  const rows = [
    {
      date: "2024-08-20",
      attendanceType: "Full Day",
      present: "Yes",
      absent: "No",
      late: "No",
    },
    {
      date: "2024-08-21",
      attendanceType: "Half Day",
      present: "Yes",
      absent: "No",
      late: "Yes",
    },
    {
      date: "2024-08-22",
      attendanceType: "Full Day",
      present: "No",
      absent: "Yes",
      late: "No",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <h3 className="mb-0">Attendance Tracking</h3>
      </CardHeader>
      <CardBody>
        <CustomTable columns={columns} rows={rows} />
      </CardBody>
    </Card>
  );
};

const LeaveManagement = () => {
  const columns = [
    "Leave Type",
    "Leave Date",
    "Leave Balance",
    "Medical Certificate",
  ];
  const token = localStorage.getItem("token");

  const rows = [
    {
      leaveType: "Sick Leave",
      leaveDate: "2024-08-20",
      leaveBalance: "5 days",
      medicalCertificate: "Yes",
    },
    {
      leaveType: "Annual Leave",
      leaveDate: "2024-08-25",
      leaveBalance: "10 days",
      medicalCertificate: "No",
    },
    {
      leaveType: "Maternity Leave",
      leaveDate: "2024-09-01",
      leaveBalance: "30 days",
      medicalCertificate: "Yes",
    },
  ];

  return (
    <Card>
      <CardHeader>
        <h3 className="mb-0">Leave Management</h3>
      </CardHeader>
      <CardBody>
        <CustomTable columns={columns} rows={rows} />
      </CardBody>
    </Card>
  );
};

const ManageStudent = () => {
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const [studentData, setStudentData] = useState(null);
  const [studentId, setStudentId] = useState(id);
  const [classNames, setClassNames] = useState([]);
  const [birthCertificatePreview, setBirthCertificatePreview] = useState(null);
  const [previousSchoolRecordsPreview, setPreviousSchoolRecordsPreview] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [birthCertificateUrl, setBirthCertificateUrl] = useState(null);
  const [previousSchoolRecordsUrl, setPreviousSchoolRecordsUrl] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: '',
    dateOfBirth: '',
    address: '',
    desiredAreaToLearn: 'm', // Initialize with valid dropdown value
    selectLessonTime: 'morning', // Initialize with valid dropdown value
    learnedSchoolAndGrade: '', // Class ID
    appearForExam: 'no', // Initialize as string to match dropdown
    birthCertificate: null,
    previousSchoolRecords: null,
    picture: null,
    fatherGuardianDetails: {
      name: '',
      profession: '',
      address: '',
      relationship: '',
      phoneNumber: '',
    },
  });

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    setFormData((prevData) => {
      const keys = name.split('.');

      if (type === 'file') {
        if (name === 'birthCertificate') {
          setBirthCertificatePreview(files[0] ? URL.createObjectURL(files[0]) : null);
        } else if (name === 'previousSchoolRecords') {
          setPreviousSchoolRecordsPreview(files[0] ? URL.createObjectURL(files[0]) : null);
        } else if (name === 'picture') {
          setPhotoPreview(files[0] ? URL.createObjectURL(files[0]) : null);
          setPhotoUrl(null);
        }
        return { ...prevData, [name]: files[0] };
      }

      if (keys.length > 1) {
        return {
          ...prevData,
          [keys[0]]: {
            ...prevData[keys[0]],
            [keys[1]]: value,
          },
        };
      } else {
        return {
          ...prevData,
          [name]: value,
        };
      }
    });
  };

  useEffect(() => {
    if (studentId) {
      fetchStudentData();
    }
    fetchClassNames();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Return yyyy-mm-dd for input type="date"
  };

  const fetchClassNames = async () => {
    try {
      const response = await fetch(`${apiURL1}/superadmin/getClassName`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setClassNames(data);
    } catch (error) {
      console.error('Error fetching class names:', error);
      toast.error('Error fetching class names!');
    }
  };

  const fetchStudentData = () => {
    setLoading(true);
    const requestBody = { studentId };

    fetch(`${apiURL1}/superadmin/getStudentById`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        const student = data.student;
        setStudentData(student);

        const formattedDate = student.dateOfBirth ? formatDate(student.dateOfBirth) : '';

        // Normalize values to match dropdown options
        const desiredAreaToLearn = student.desiredAreaToLearn === 'Memorizing Qur’an' ? 'm' : 's';
        const selectLessonTime = student.selectLessonTime?.toLowerCase() || 'morning';
        const appearForExam = student.appearForExam ? 'yes' : 'no';

        setFormData((prevData) => ({
          ...prevData,
          fullName: student.fullName || '',
          dateOfBirth: formattedDate,
          address: student.address || '',
          desiredAreaToLearn,
          selectLessonTime,
          learnedSchoolAndGrade: student.learnedSchoolAndGrade || '',
          regNo: student.registrationNumber || '',
          appearForExam,
          fatherGuardianDetails: {
            name: student.fatherGuardianDetails?.name || '',
            profession: student.fatherGuardianDetails?.profession || '',
            address: student.fatherGuardianDetails?.address || '',
            relationship: student.fatherGuardianDetails?.relationship || '',
            phoneNumber: student.fatherGuardianDetails?.phoneNumber || '',
          },
        }));

        setBirthCertificateUrl(student.birthCertificate || null);
        setPreviousSchoolRecordsUrl(student.degree || null);
        setPhotoUrl(student.picture || null);
      })
      .catch((error) => {
        toast.error('Error during fetching student detail!');
        console.error('Error fetching student data:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSave = () => {
    setLoading(true);

    // Use formData directly instead of document.getElementById
    const updatedStudentData = {
      fullName: formData.fullName,
      dateOfBirth: formData.dateOfBirth,
      address: formData.address,
      desiredAreaToLearn: formData.desiredAreaToLearn === 'm' ? 'Memorizing Qur’an' : 'Shari yah studies',
      selectLessonTime: formData.selectLessonTime === 'morning' ? 'Morning' : 'Evening',
      learnedSchoolAndGrade: formData.learnedSchoolAndGrade,
      appearForExam: formData.appearForExam === 'yes',
      fatherGuardianDetails: {
        name: formData.fatherGuardianDetails.name,
        profession: formData.fatherGuardianDetails.profession,
        address: formData.fatherGuardianDetails.address,
        relationship: formData.fatherGuardianDetails.relationship,
        phoneNumber: formData.fatherGuardianDetails.phoneNumber,
      },
    };

    const form = new FormData();
    for (const key in updatedStudentData) {
      if (updatedStudentData[key] !== null && updatedStudentData[key] !== undefined) {
        if (typeof updatedStudentData[key] === 'object') {
          for (const nestedKey in updatedStudentData[key]) {
            form.append(`${key}.${nestedKey}`, updatedStudentData[key][nestedKey]);
          }
        } else {
          form.append(key, updatedStudentData[key]);
        }
      }
    }
    if (formData.birthCertificate) {
      form.append('certificate', formData.birthCertificate);
    }
    if (formData.previousSchoolRecords) {
      form.append('degree', formData.previousSchoolRecords);
    }
    if (formData.picture) {
      form.append('pic', formData.picture);
    }

    fetch(`${apiURL1}/superadmin/studentsDetail/${studentId}`, {
      method: 'PUT',
      body: form,
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then(() => {
        toast.success('Student updated successfully!');
        fetchStudentData();
      })
      .catch((error) => {
        toast.error('Error updating Student!');
        console.error('Error saving student data:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!studentData) {
    return <div>Loading...</div>;
  }

  const findClassName = (classId) => {
    const foundClass = classNames.find((cls) => cls._id === classId);
    return foundClass ? foundClass.className : 'N/A';
  };

  const handleDownload = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container className="mt--7" fluid>
      <Row>
        <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
          <Card className="card-profile shadow">
            <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
              <div className="d-flex justify-content-between"></div>
            </CardHeader>
            <CardBody className="pt-0 pt-md-4">
              <Row>
                <div className="col">
                  <div className="text-center">
                    {photoPreview || photoUrl ? (
                      <img
                        src={photoPreview || photoUrl}
                        alt="Profile"
                        className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                        style={{ width: '140px', height: '140px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div
                        style={{
                          width: '140px',
                          height: '140px',
                          borderRadius: '50%',
                          backgroundColor: '#f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      >
                        No Image
                      </div>
                    )}
                    <h3>Name: {formData.fullName || 'N/A'}</h3>
                    <div className="h5">
                      <i className="ni location_pin mr-2" />
                      Reg No: {formData.regNo || 'N/A'}
                    </div>
                    <div className="h5">
                      <i className="ni location_pin mr-2" />
                      Address: {formData.address || 'N/A'}
                    </div>
                    <div className="h5 mt-4">
                      <i className="ni calendar-grid-58 mr-2" />
                      Date of Birth: {formData.dateOfBirth || 'N/A'}
                    </div>
                    <div className="h5 mt-4">
                      <i className="ni hat-3 mr-2" />
                      Desired Area to Learn: {formData.desiredAreaToLearn === 'm' ? 'Memorizing Qur’an' : 'Shari yah studies'}
                    </div>
                    <div className="h5 mt-4">
                      <i className="ni time-alarm mr-2" />
                      Lesson Time: {formData.selectLessonTime === 'morning' ? 'Morning' : 'Evening'}
                    </div>
                    <div className="h5 mt-4">
                      <i className="ni building mr-2" />
                      Grade: {findClassName(formData.learnedSchoolAndGrade) || 'N/A'}
                    </div>
                    <div className="h5 mt-4">
                      <i className="ni education_hat mr-2" />
                      {formData.appearForExam === 'yes' ? 'Appearing for Exam' : 'Not Appearing for Exam'}
                    </div>
                    <div className="h5 mt-4">
                      <i className="ni single-02 mr-2" />
                      Father/Guardian Name: {formData.fatherGuardianDetails.name || 'N/A'}
                    </div>
                  </div>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col className="order-xl-1" xl="8">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="8">
                  <h3 className="mb-0">Student Registration</h3>
                </Col>
                <Col className="text-right" xs="4">
                  <Button color="primary" onClick={handleSave} size="sm" disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form>
                <h6 className="heading-small text-muted mb-4">Student Information</h6>
                <div className="pl-lg-4">
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-student-name-with-initial">
                          Name with Initial
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-student-name-with-initial"
                          name="fullName"
                          type="text"
                          placeholder="Enter name"
                          value={formData.fullName}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-date-of-birth">
                          Date of Birth
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-date-of-birth"
                          type="date"
                          name="dateOfBirth"
                          value={formData.dateOfBirth}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-address">
                          Address
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-address"
                          type="text"
                          name="address"
                          placeholder="Enter address"
                          value={formData.address}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-area-to-learn">
                          Desired Area to Learn
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-area-to-learn"
                          type="select"
                          name="desiredAreaToLearn"
                          value={formData.desiredAreaToLearn}
                          onChange={handleInputChange}
                        >
                          <option value="m">Memorizing Qur’an</option>
                          <option value="s">Shari yah studies</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-lesson-time">
                          Lesson Time
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-lesson-time"
                          type="select"
                          name="selectLessonTime"
                          value={formData.selectLessonTime}
                          onChange={handleInputChange}
                        >
                          <option value="morning">Morning</option>
                          <option value="evening">Evening</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-learned-school-grade">
                          Learned School & Grade
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-learned-school-grade"
                          type="select"
                          name="learnedSchoolAndGrade"
                          value={formData.learnedSchoolAndGrade}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Grade</option>
                          {classNames.map((className) => (
                            <option key={className._id} value={className._id}>
                              {className.className}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-appear-for-exam">
                          Appearing for Exam
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-appear-for-exam"
                          type="select"
                          name="appearForExam"
                          value={formData.appearForExam}
                          onChange={handleInputChange}
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-birth-certificate">
                          Birth Certificate
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-birth-certificate"
                          type="file"
                          name="birthCertificate"
                          onChange={handleInputChange}
                        />
                        {birthCertificatePreview && (
                          <img
                            src={birthCertificatePreview}
                            alt="Birth Certificate Preview"
                            style={{ maxWidth: '100px', marginTop: '10px' }}
                          />
                        )}
                        {birthCertificateUrl && (
                          <a
                            href={birthCertificateUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => handleDownload(birthCertificateUrl, 'birthCertificate.zip')}
                          >
                            Download Birth Certificate <FaDownload />
                          </a>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-previous-school-records">
                          Previous School Records
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-previous-school-records"
                          type="file"
                          name="previousSchoolRecords"
                          onChange={handleInputChange}
                        />
                        {previousSchoolRecordsPreview && (
                          <img
                            src={previousSchoolRecordsPreview}
                            alt="Previous School Records Preview"
                            style={{ maxWidth: '100px', marginTop: '10px' }}
                          />
                        )}
                        {previousSchoolRecordsUrl && (
                          <a
                            href={previousSchoolRecordsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => handleDownload(previousSchoolRecordsUrl, 'previousSchoolRecords.zip')}
                          >
                            Download Previous School Records <FaDownload />
                          </a>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-photo">
                          Picture
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-photo"
                          type="file"
                          name="picture"
                          onChange={handleInputChange}
                        />
                        {photoPreview && (
                          <img
                            src={photoPreview}
                            alt="Photo Preview"
                            style={{ maxWidth: '100px', marginTop: '10px' }}
                          />
                        )}
                        {photoUrl && !photoPreview && (
                          <img
                            src={photoUrl}
                            alt="Photo Preview"
                            style={{ maxWidth: '100px', marginTop: '10px' }}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <hr className="my-4" />
                  <h6 className="heading-small text-muted mb-4">Father/Guardian Information</h6>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-father-name">
                          Father's Name
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-father-name"
                          type="text"
                          name="fatherGuardianDetails.name"
                          placeholder="Enter name"
                          value={formData.fatherGuardianDetails.name}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-father-profession">
                          Father's Profession
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-father-profession"
                          type="text"
                          name="fatherGuardianDetails.profession"
                          placeholder="Enter profession"
                          value={formData.fatherGuardianDetails.profession}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-father-address">
                          Father's Address
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-father-address"
                          type="text"
                          name="fatherGuardianDetails.address"
                          placeholder="Enter address"
                          value={formData.fatherGuardianDetails.address}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-father-relationship">
                          Relationship with Student
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-father-relationship"
                          type="text"
                          name="fatherGuardianDetails.relationship"
                          placeholder="Enter Relationship"
                          value={formData.fatherGuardianDetails.relationship}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <FormGroup>
                        <label className="form-control-label" htmlFor="input-father-phone">
                          Father's Phone Number
                        </label>
                        <Input
                          className="form-control-alternative"
                          id="input-father-phone"
                          name="fatherGuardianDetails.phoneNumber"
                          type="text"
                          placeholder="Enter phone number"
                          value={formData.fatherGuardianDetails.phoneNumber}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Footer />
    </Container>
  );
};



const FeeManagement = () => {
  const { id } = useParams();
  const [fees, setFees] = useState([]);
  const token = localStorage.getItem('token');
  const [newFee, setNewFee] = useState({
    paidDate: '',
    amount: '',
    monthYear: null, // Use Date object for month/year picker
    isFullPay: true,
    notes: '',
    pending: 0,
    isBank: false
  });
  const [editFee, setEditFee] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteFeeId, setDeleteFeeId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState({
    monthYear: null,
    status: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedFee, setSelectedFee] = useState(null);
  const [studentInfo, setStudentInfo] = useState({
    studentName: '',
    studentReg: ''
  });
  const [madrasaInfo, setMadrasaInfo] = useState({
    schoolName: '',
    schoolAddress: '',
    schoolPhoneNumber: '',
    schoolEmail: ''
  });
  const baseURL = apiURL1;
  const itemsPerPage = 10;

  useEffect(() => {
    fetchMadrasaInfo();
  }, []);

  const fetchMadrasaInfo = async () => {
    try {
      const response = await fetch(`${baseURL}/superadmin/school-settings`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.length > 0) {
        setMadrasaInfo(data[0]);
      } else {
        console.warn('No madrasa info returned');
      }
    } catch (error) {
      console.error('Error fetching madrasa info:', error);
      toast.error('Failed to fetch madrasa info');
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  useEffect(() => {
    fetchFees();
  }, [currentPage, filter, id]);

  const fetchFees = async () => {
    setLoading(true);
    try {
      let url = `${baseURL}/superadmin/students/${id}/fees?page=${currentPage}&limit=${itemsPerPage}`;
      if (filter.monthYear) {
        const month = dayjs(filter.monthYear).format('MM');
        const year = dayjs(filter.monthYear).format('YYYY');
        url = `${baseURL}/superadmin/students/${id}/fees/filter?month=${month}&year=${year}`;
      }
      if (filter.status) {
        const params = new URLSearchParams();
        params.append('status', filter.status);
        url += `&${params.toString()}`;
      }
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.fees && Array.isArray(data.fees)) {
        setFees(data.fees);
        setTotalPages(data.totalPages || 1);
        setStudentInfo({
          studentName: data.studentName || 'N/A',
          studentReg: data.studentReg || 'N/A'
        });
      } else {
        setFees([]);
        setTotalPages(1);
        setStudentInfo({
          studentName: data.studentName || 'N/A',
          studentReg: data.studentReg || 'N/A'
        });
      }
    } catch (error) {
      console.error('Error fetching fees:', error);
      toast.error('Error fetching fees!');
    } finally {
      setLoading(false);
    }
  };

  const validateFee = (fee) => {
    const newErrors = {};
    if (!fee.paidDate) newErrors.paidDate = 'Paid date is required';
    if (!fee.amount || fee.amount <= 0) newErrors.amount = 'Amount must be a positive number';
    if (!fee.monthYear) {
      newErrors.monthYear = 'Month and year are required';
    } else {
      const month = dayjs(fee.monthYear).month() + 1;
      const year = dayjs(fee.monthYear).year();
      if (!Number.isInteger(month) || month < 1 || month > 12) {
        newErrors.monthYear = 'Month must be between 1 and 12';
      }
      if (!Number.isInteger(year) || year < 2000) {
        newErrors.monthYear = 'Year must be >= 2000';
      }
    }
    if (fee.isFullPay === undefined) newErrors.isFullPay = 'Full pay status is required';
    if (fee.isBank === undefined) newErrors.isBank = 'Payment method is required';
    if (!fee.isFullPay && (!fee.pending || fee.pending <= 0)) {
      newErrors.pending = 'Pending amount must be a positive number';
    }
    return newErrors;
  };

  const handleAddFee = async (e) => {
    e.preventDefault();
    const feeToValidate = {
      ...newFee,
      month: newFee.monthYear ? dayjs(newFee.monthYear).month() + 1 : null,
      year: newFee.monthYear ? dayjs(newFee.monthYear).year() : null
    };
    const validationErrors = validateFee(feeToValidate);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Please fill all required fields correctly');
      return;
    }
    try {
      const response = await fetch(`${baseURL}/superadmin/students/${id}/fees`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...newFee,
          month: dayjs(newFee.monthYear).month() + 1,
          year: dayjs(newFee.monthYear).year()
        }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success('Fee added successfully!');
        fetchFees();
        setNewFee({
          paidDate: '',
          amount: '',
          monthYear: null,
          isFullPay: true,
          notes: '',
          pending: 0,
          isBank: false
        });
        setModalOpen(false);
        setErrors({});
      } else {
        toast.error(data.message || 'Error adding fee!');
      }
    } catch (error) {
      console.error('Error adding fee:', error);
      toast.error('Error adding fee!');
    }
  };

  const handleEditFee = (fee) => {
    setEditFee({
      ...fee,
      paidDate: fee.paidDate.split('T')[0],
      monthYear: fee.month && fee.year ? new Date(fee.year, fee.month - 1) : null
    });
    setEditModalOpen(true);
    setErrors({});
  };

  const handleUpdateFee = async (e) => {
    e.preventDefault();
    const feeToValidate = {
      ...editFee,
      month: editFee.monthYear ? dayjs(editFee.monthYear).month() + 1 : null,
      year: editFee.monthYear ? dayjs(editFee.monthYear).year() : null
    };
    const validationErrors = validateFee(feeToValidate);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Please fill all required fields correctly');
      return;
    }
    try {
      const response = await fetch(`${baseURL}/superadmin/students/${id}/fees/${editFee._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...editFee,
          month: dayjs(editFee.monthYear).month() + 1,
          year: dayjs(editFee.monthYear).year()
        }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success('Fee updated successfully!');
        fetchFees();
        setEditFee(null);
        setEditModalOpen(false);
        setErrors({});
      } else {
        toast.error(data.message || 'Error updating fee!');
      }
    } catch (error) {
      console.error('Error updating fee:', error);
      toast.error('Error updating fee!');
    }
  };

  const handleDeleteFee = (feeId) => {
    setDeleteFeeId(feeId);
    setDeleteModalOpen(true);
  };

  const handleViewFee = (fee) => {
    setSelectedFee(fee);
    setViewModalOpen(true);
  };

  const confirmDeleteFee = async () => {
    try {
      const response = await fetch(`${baseURL}/superadmin/students/${id}/fees/${deleteFeeId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      toast.success(data.message || 'Fee deleted successfully!');
      fetchFees();
    } catch (error) {
      console.error('Error deleting fee:', error);
      toast.error('Error deleting fee!');
    } finally {
      setDeleteModalOpen(false);
      setDeleteFeeId(null);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (date) => {
    setFilter({ ...filter, monthYear: date });
  };

  const applyFilters = () => {
    setCurrentPage(1);
    fetchFees();
  };

  const handlePrintAll = async () => {
    try {
      let url = `${baseURL}/superadmin/students/${id}/fees`;
      const params = new URLSearchParams();
      if (filter.monthYear) {
        const month = dayjs(filter.monthYear).format('MM');
        const year = dayjs(filter.monthYear).format('YYYY');
        url = `${baseURL}/superadmin/students/${id}/fees/filter?month=${month}&year=${year}`;
      }
      if (filter.status) {
        params.append('status', filter.status);
      }
      const queryString = params.toString();
      if (queryString) {
        url += (url.includes('?') ? '&' : '?') + queryString;
      }

      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (data?.fees?.length) {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
          <html>
            <head>
              <title>Fee Report</title>
              <style>
                body { font-family: Arial; margin: 20px; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }
                .header { text-align: center; margin-bottom: 20px; }
                .logo { width: 100px; height: 100px; }
              </style>
            </head>
            <body>
              <div class="header">
                <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
                     alt="School Logo" class="logo"/>
                <h2>${madrasaInfo.schoolName}</h2>
                <p>${madrasaInfo.schoolAddress}</p>
                <p>Phone: ${madrasaInfo.schoolPhoneNumber} | Email: ${madrasaInfo.schoolEmail}</p>
                <hr>
                <h3>Fee Report</h3>
                <p><strong>Student:</strong> ${studentInfo.studentName} (${studentInfo.studentReg})</p>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Receipt #</th>
                    <th>Paid Date</th>
                    <th>Fee For</th>
                    <th>Amount</th>
                    <th>Pending</th>
                    <th>Full Pay</th>
                    <th>Status</th>
                    <th>Payment Method</th>
                  </tr>
                </thead>
                <tbody>
                  ${data.fees.map(fee => `
                    <tr>
                      <td>${fee.receiptNumber || 'N/A'}</td>
                      <td>${formatDate(fee.paidDate)}</td>
                      <td>${fee.month && fee.year ? `${String(fee.month).padStart(2, '0')}-${fee.year}` : fee.monthString || 'N/A'}</td>
                      <td>${fee.amount}</td>
                      <td>${fee.pending}</td>
                      <td>${fee.isFullPay ? 'Yes' : 'No'}</td>
                      <td>${fee.status}</td>
                      <td>${fee.isBank ? 'Bank' : 'Cash'}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      } else {
        toast.error('No fees to print');
      }
    } catch (error) {
      console.error('Print error:', error);
      toast.error('Failed to generate print');
    }
  };

  const getRowStyle = (status) => {
    switch (status) {
      case 'part paid':
        return 'table-warning';
      case 'pending':
        return 'table-danger';
      case 'paid':
        return 'table-success';
      default:
        return '';
    }
  };

  const printReceipt = (fee) => {
    const studentName = studentInfo?.studentName || 'N/A';
    const studentReg = studentInfo?.studentReg || 'N/A';
    const receiptNumber = fee?.receiptNumber || 'N/A';
    const paidDate = fee?.paidDate ? formatDate(fee.paidDate) : 'N/A';
    const feeFor = fee.month && fee.year ? `${String(fee.month).padStart(2, '0')}-${fee.year}` : fee.monthString || 'N/A';
    const amount = fee?.amount || 'N/A';
    const pending = fee?.pending || '0.0';
    const isFullPay = fee?.isFullPay ? 'Yes' : 'No';
    const status = fee?.status || 'N/A';
    const notes = fee?.notes || 'N/A';
    const paymentMethod = fee?.isBank ? 'BANK' : 'CASH';

    const maxStudentNameLength = 20;
    const truncatedStudentName =
      studentName.length > maxStudentNameLength ? studentName.substring(0, maxStudentNameLength) + '...' : studentName;

    const amountInWordsText = isNaN(amount) ? amount : amountInWords(parseInt(amount));

    const receiptContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Payment Receipt</title>
      <style>
        @page { size: A5; margin: 0; }
        body {
          width: 148mm;
          height: 210mm;
          margin: 0 auto;
          padding: 10mm;
          box-sizing: border-box;
          font-family: sans-serif;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
        .page-content {
          height: 100%;
          overflow: hidden;
          width: 100%;
          max-width: 128mm;
        }
        .receipt-header {
          text-align: center;
          margin-bottom: 15px;
        }
        .receipt-header h2 { margin: 5px 0; font-size: 16px; }
        .receipt-header h3 { margin: 10px 0; font-size: 15px; }
        .receipt-header p { margin: 2px 0; font-size: 12px; }
        .field-row { display: flex; justify-content: space-between; margin-bottom: 8px; }
        .field-label { margin: 4px 0; font-size: 13px; }
        .field-value { border-bottom: 1px solid black; font-size: 13px; }
      </style>
    </head>
    <body>
      <div class="page-content">
        <div class="receipt-header">
          <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
                alt="Madrasa Logo" 
                style="width: 80px; height: 80px; margin-bottom: 10px;">
          <h2>${madrasaInfo.schoolName || 'N/A'}</h2>
          <p>${madrasaInfo.schoolAddress || 'N/A'}</p>
          <p>Phone: ${madrasaInfo.schoolPhoneNumber || 'N/A'} | Email: ${madrasaInfo.schoolEmail || 'N/A'}</p>
          <hr style="border: 0.5px solid #000; margin: 15px 0;">
          <h3>PAYMENT RECEIPT</h3>
        </div>
        <div style="margin-bottom: 10px; text-align: right;">
          <p style="margin: 4px 0; font-size: 13px;"><strong>Receipt Number:</strong> <span style="border-bottom: 1px solid black;">${receiptNumber}</span></p>
          <p style="margin: 4px 0; font-size: 13px;"><strong>Date:</strong> <span style="border-bottom: 1px solid black;">${paidDate}</span></p>
        </div>
        <div class="field-row">
          <p class="field-label"><strong>Student Name:</strong> <span class="field-value">${truncatedStudentName}</span></p>
          <p class="field-label"><strong>Registration:</strong> <span class="field-value">${studentReg}</span></p>
        </div>
        <div class="field-row">
          <p class="field-label"><strong>Fee For:</strong> <span class="field-value">${feeFor}</span></p>
        </div>
        <div style="margin-bottom: 10px;">
          <p class="field-label"><strong>Amount in Words:</strong> <span class="field-value">${amountInWordsText}</span></p>
        </div>
        <div style="margin-bottom: 10px;">
          <div class="field-row">
            <p class="field-label"><strong>Amount:</strong> <span class="field-value">${amount}</span></p>
            <p class="field-label"><strong>Payment Method:</strong> <span class="field-value">${paymentMethod}</span></p>
          </div>
          <div class="field-row">
            <p class="field-label"><strong>Full Pay:</strong> <span class="field-value">${isFullPay}</span></p>
            <p class="field-label"><strong>Status:</strong> <span class="field-value">${status}</span></p>
            <p class="field-label"><strong>Pending Amount:</strong> <span class="field-value">${pending}</span></p>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <p class="field-label"><strong>Received By:</strong> <p style="margin: 4px 0; font-size: 16px">______________________</p></p>
          <p class="field-label"><strong>Notes:</strong> <span class="field-value">${notes}</span></p>
        </div>
      </div>
    </body>
    </html>
    `;
    const printWindow = window.open('', '', 'width=900,height=1300');
    printWindow.document.write(receiptContent);
    printWindow.document.close();
    printWindow.print();
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const amountInWords = (num) => {
    const ones = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'
    ];
    const teens = [
      'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];

    if (num === 0) return 'Zero';
    if (isNaN(num)) return 'Invalid Amount';

    let words = '';
    if (num >= 100000) {
      const lakhsValue = Math.floor(num / 100000);
      words += convertTwoDigits(lakhsValue) + ' Lakh ';
      num %= 100000;
    }
    if (num >= 1000) {
      const thousandsValue = Math.floor(num / 1000);
      words += convertTwoDigits(thousandsValue) + ' Thousand ';
      num %= 1000;
    }
    if (num >= 100) {
      words += ones[Math.floor(num / 100)] + ' Hundred ';
      num %= 100;
    }
    if (num > 0) {
      if (words.length > 0) words += 'and ';
      words += convertTwoDigits(num);
    }
    return words.trim();

    function convertTwoDigits(n) {
      if (n === 0) return '';
      if (n < 10) return ones[n];
      if (n >= 10 && n < 20) return teens[n - 10];
      const tensDigit = Math.floor(n / 10);
      const onesDigit = n % 10;
      if (onesDigit === 0) return tens[tensDigit];
      return tens[tensDigit] + ' ' + ones[onesDigit];
    }
  };

  const renderPagination = () => {
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    const pageNumbers = Array.from({ length: (endPage - startPage + 1) }, (_, i) => startPage + i);

    return (
      <Pagination>
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
        </PaginationItem>
        {pageNumbers.map((page) => (
          <PaginationItem key={page} active={page === currentPage}>
            <PaginationLink onClick={() => handlePageChange(page)}>
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <>
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <div>
            <h3 className="mb-0">Fee Management</h3>
            <p className="mb-0 text-lg mt-3">
              <strong>Student Name:</strong> {studentInfo.studentName} | <strong>Reg No:</strong> {studentInfo.studentReg}
            </p>
          </div>
          <div>
            <Button color="primary" onClick={() => setModalOpen(true)}>
              <FaPlus /> Add New
            </Button>
            <Button color="success" onClick={handlePrintAll}>
              <FaPrint /> Print All
            </Button>
          </div>
        </CardHeader>
        <CardBody>
          <div className="d-flex align-items-center mb-3">
            <DatePicker
              selected={filter.monthYear}
              onChange={handleFilterChange}
              dateFormat="MM-yyyy"
              showMonthYearPicker
              showTwoColumnMonthYearPicker
              placeholderText="Select Month and Year"
              className="form-control"
              style={{ width: '200px', marginRight: '10px' }}
            />
            <Button color="primary" onClick={applyFilters}>
              Apply Filters
            </Button>
          </div>
          {loading ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th>Receipt Number</th>
                  <th>Paid Date</th>
                  <th>Fee For</th>
                  <th>Amount</th>
                  <th>Pending Amount</th>
                  <th>Full Pay</th>
                  <th>Status</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {fees && fees.length > 0 ? (
                  fees.map((fee) => (
                    <tr key={fee._id} className={getRowStyle(fee.status)}>
                      <td>{fee.receiptNumber || 'N/A'}</td>
                      <td>{formatDate(fee.paidDate)}</td>
                      <td>{fee.month && fee.year ? `${String(fee.month).padStart(2, '0')}-${fee.year}` : fee.monthString || 'N/A'}</td>
                      <td>{fee.amount}</td>
                      <td>{fee.pending}</td>
                      <td>{fee.isFullPay ? 'Yes' : 'No'}</td>
                      <td>{fee.status}</td>
                      <td>{truncateText(fee.notes, 50)}</td>
                      <td>
                        {fee.status !== 'pending' ? (
                          <ButtonGroup size="sm">
                            <Button color="info" className="mr-1" onClick={() => handleViewFee(fee)}>
                              View
                            </Button>
                            <Button color="primary" className="mr-1" onClick={() => handleEditFee(fee)}>
                              <FaPencilAlt />
                            </Button>
                            <Button color="danger" className="mr-1" onClick={() => handleDeleteFee(fee._id)}>
                              <FaTrash />
                            </Button>
                            <Button color="secondary" onClick={() => printReceipt(fee)}>
                              <FaPrint />
                            </Button>
                          </ButtonGroup>
                        ) : (<></>)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">No records found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          {totalPages > 1 && renderPagination()}
        </CardBody>
      </Card>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>Add New Fee</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleAddFee}>
            <FormGroup>
              <Label>Paid Date <span className="text-danger">*</span></Label>
              <Input
                type="date"
                value={newFee.paidDate}
                onChange={(e) => setNewFee({ ...newFee, paidDate: e.target.value })}
                invalid={!!errors.paidDate}
              />
              {errors.paidDate && <div className="invalid-feedback">{errors.paidDate}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Fee For Month & Year <span className="text-danger">*</span></Label>
              <DatePicker
                selected={newFee.monthYear}
                onChange={(date) => setNewFee({ ...newFee, monthYear: date })}
                dateFormat="MM-yyyy"
                showMonthYearPicker
                showTwoColumnMonthYearPicker
                placeholderText="Select Month and Year"
                className={`form-control ${errors.monthYear ? 'is-invalid' : ''}`}
              />
              {errors.monthYear && <div className="invalid-feedback">{errors.monthYear}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Amount <span className="text-danger">*</span></Label>
              <Input
                type="number"
                placeholder="Enter amount"
                value={newFee.amount}
                onChange={(e) => setNewFee({ ...newFee, amount: e.target.value })}
                invalid={!!errors.amount}
                min="0"
              />
              {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
            </FormGroup>
            {!newFee.isFullPay && (
              <FormGroup>
                <Label>Pending Amount <span className="text-danger">*</span></Label>
                <Input
                  type="number"
                  placeholder="Enter pending amount"
                  value={newFee.pending}
                  onChange={(e) => setNewFee({ ...newFee, pending: e.target.value })}
                  invalid={!!errors.pending}
                  min="0"
                />
                {errors.pending && <div className="invalid-feedback">{errors.pending}</div>}
              </FormGroup>
            )}
            <FormGroup className="d-flex align-items-center">
              <Label className="mr-2">Full Pay <span className="text-danger">*</span></Label>
              <Input
                type="checkbox"
                checked={newFee.isFullPay}
                onChange={(e) => setNewFee({ ...newFee, isFullPay: e.target.checked, pending: e.target.checked ? 0 : newFee.pending })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Payment Method <span className="text-danger">*</span></Label>
              <Input
                type="select"
                value={newFee.isBank ? 'bank' : 'cash'}
                onChange={(e) => setNewFee({ ...newFee, isBank: e.target.value === 'bank' })}
                invalid={!!errors.isBank}
              >
                <option value="">Select Payment Method</option>
                <option value="cash">Cash</option>
                <option value="bank">Bank Deposit</option>
              </Input>
              {errors.isBank && <div className="invalid-feedback">{errors.isBank}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Notes (optional)</Label>
              <Input
                type="textarea"
                placeholder="Enter notes (optional)"
                value={newFee.notes}
                onChange={(e) => setNewFee({ ...newFee, notes: e.target.value })}
              />
            </FormGroup>
            <Button color="primary" type="submit" disabled={Object.keys(errors).length > 0}>
              Add Fee
            </Button>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setModalOpen(false); setErrors({}); }}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
        <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Fee</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleUpdateFee}>
            <FormGroup>
              <Label>Receipt Number</Label>
              <Input
                type="text"
                placeholder="Enter receipt number"
                value={editFee?.receiptNumber || ''}
                readOnly
              />
            </FormGroup>
            <FormGroup>
              <Label>Paid Date <span className="text-danger">*</span></Label>
              <Input
                type="date"
                value={editFee?.paidDate || ''}
                onChange={(e) => setEditFee({ ...editFee, paidDate: e.target.value })}
                invalid={!!errors.paidDate}
              />
              {errors.paidDate && <div className="invalid-feedback">{errors.paidDate}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Fee For Month & Year <span className="text-danger">*</span></Label>
              <DatePicker
                selected={editFee?.monthYear}
                onChange={(date) => setEditFee({ ...editFee, monthYear: date })}
                dateFormat="MM-yyyy"
                showMonthYearPicker
                showTwoColumnMonthYearPicker
                placeholderText="Select Month and Year"
                className={`form-control ${errors.monthYear ? 'is-invalid' : ''}`}
              />
              {errors.monthYear && <div className="invalid-feedback">{errors.monthYear}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Amount <span className="text-danger">*</span></Label>
              <Input
                type="number"
                placeholder="Enter amount"
                value={editFee?.amount || ''}
                onChange={(e) => setEditFee({ ...editFee, amount: e.target.value })}
                invalid={!!errors.amount}
                min="0"
              />
              {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
            </FormGroup>
            {!editFee?.isFullPay && (
              <FormGroup>
                <Label>Pending Amount <span className="text-danger">*</span></Label>
                <Input
                  type="number"
                  placeholder="Enter pending amount"
                  value={editFee?.pending || ''}
                  onChange={(e) => setEditFee({ ...editFee, pending: e.target.value })}
                  invalid={!!errors.pending}
                  min="0"
                />
                {errors.pending && <div className="invalid-feedback">{errors.pending}</div>}
              </FormGroup>
            )}
            <FormGroup className="d-flex align-items-center">
              <Label className="mr-2">Full Pay <span className="text-danger">*</span></Label>
              <Input
                type="checkbox"
                checked={editFee?.isFullPay || false}
                onChange={(e) => setEditFee({ ...editFee, isFullPay: e.target.checked, pending: e.target.checked ? 0 : editFee.pending })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Payment Method <span className="text-danger">*</span></Label>
              <Input
                type="select"
                value={editFee?.isBank ? 'bank' : 'cash'}
                onChange={(e) => setEditFee({ ...editFee, isBank: e.target.value === 'bank' })}
                invalid={!!errors.isBank}
              >
                <option value="">Select Payment Method</option>
                <option value="cash">Cash</option>
                <option value="bank">Bank Deposit</option>
              </Input>
              {errors.isBank && <div className="invalid-feedback">{errors.isBank}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Notes (optional)</Label>
              <Input
                type="textarea"
                placeholder="Enter notes (optional)"
                value={editFee?.notes || ''}
                onChange={(e) => setEditFee({ ...editFee, notes: e.target.value })}
              />
            </FormGroup>
            <Button color="primary" type="submit" disabled={Object.keys(errors).length > 0}>
              Update Fee
            </Button>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setEditModalOpen(false); setErrors({}); }}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
        <ModalHeader toggle={() => setDeleteModalOpen(false)}>Delete Fee</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to delete this fee?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDeleteFee}>
            Yes, Delete
          </Button>
          <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)} size="lg">
        <ModalHeader toggle={() => setViewModalOpen(false)}>Fee Details</ModalHeader>
        <ModalBody>
          {selectedFee && (
            <div>
              <p><strong>Receipt Number:</strong> {selectedFee.receiptNumber || 'N/A'}</p>
              <p><strong>Paid Date:</strong> {formatDate(selectedFee.paidDate)}</p>
              <p><strong>Fee For:</strong> {selectedFee.month && selectedFee.year ? `${String(selectedFee.month).padStart(2, '0')}-${selectedFee.year}` : selectedFee.monthString || 'N/A'}</p>
              <p><strong>Amount:</strong> {selectedFee.amount}</p>
              <p><strong>Pending Amount:</strong> {selectedFee.pending}</p>
              <p><strong>Full Pay:</strong> {selectedFee.isFullPay ? 'Yes' : 'No'}</p>
              <p><strong>Status:</strong> {selectedFee.status}</p>
              <p><strong>Payment Method:</strong> {selectedFee.isBank ? 'Bank' : 'Cash'}</p>
              <p><strong>Notes:</strong> {selectedFee.notes || 'N/A'}</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setViewModalOpen(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Footer />
    </>
  );
};
